module.exports = __webpack_public_path__ + "static/media/tags-guideline.3af1fcb0.png";